import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  accessTokenAction,
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  bloodGroupAction,
  genderAction,
  idProofAction,
  insuranceProviderAction,
  updatePatientAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import SelectField from "../forms/select-field";
import {
  doctorListAction,
  priceListAction,
} from "../../redux/actions/general-action";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { handelLabel } from "./handel-label";
import { handelEnabled } from "./handel-enabled";
import MobileIcon from "../../assets/icons/admin-customer-icons/mobile-icon";
import { Plus } from "lucide-react";
import Patient2Icon from "../../assets/icons/admin-customer-icons/patient2-icon";
import { api } from "../../redux/apis/api";
import axios from "axios";
import { url } from "../../redux/config";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Patient({
  customerId,
  patient,
  page,
  disabled,
  // loading,
  // setLoading,
  patientId,
  setCurrentTab,
  popUp,
  setPopUp,
  customization,
  tokenExpiresIn,
  setTokenExpiresIn,
  setTxnId,
  txnId,
  ABHAverified,
  setABHAverified,
  accessToken,
  setAccessToken,
  createABHApopUp,
  setCreateABHApopUp,
  setFindABHApopup,
}) {
  const [terms, setTerms] = useState(null);
  const [priceList, setPriceList] = useState(null);
  const [discountGroup, setDiscountGroup] = useState(null);
  // const [genderList, setGenderList] = useState(null);
  // const [bloodGroupList, setBloodGroupList] = useState(null);
  const [doctorList, setDoctorList] = useState(null);
  // const [idList, setIdList] = useState(null);
  const [customData, setcustomData] = useState([]);
  const [ABHA, setABHA] = useState("");

  const [loading, setLoading] = useState(false);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const bloodGroupList = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
  ];
  const genderList = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Transgender", label: "Transgender" },
    { value: "Prefer Not to Say", label: "Prefer Not to Say" },
  ];
  const idList = [
    { value: "Aadhaar Card", label: "Aadhaar Card" },
    { value: "PAN Card", label: "PAN Card" },
    { value: "Passport", label: "Passport" },
    { value: "Driving License", label: "Driving License" },
    { value: "Voter ID", label: "Voter ID" },
    { value: "Employee ID", label: "Employee ID" },
    { value: "Student ID", label: "Student ID" },
    { value: "Other", label: "Other" },
  ];

  let initialValues = {
    patient: localStorageData?.patient ?? patient,
  };
  initialValues?.patient?.cmr_dob &&
  (initialValues.patient.cmr_dob = moment(initialValues.patient.cmr_dob).format("YYYY-MM-DD"));
  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
    }));
  }
  function convertPriceList(input) {
    return input.map((item) => ({
      value: item.price_list_id,
      label: item.price_list_name,
    }));
  }
  function convertGenderList(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
    }));
  }
  function convertDoctorrList(input) {
    return input.map((item) => ({
      value: item.dr_name,
      label: item.dr_name,
    }));
  }
  const onSuccess = () => {
    setLoading(false);
    successToast("Saved successfully");
    setCurrentTab("Family Info");
  };
  const onListSuccess = (data) => {
    const res = convertArray(data.data);
    setTerms(res);
    setLoading(false);
  };
  const onPriceSuccess = (data) => {
    const res = convertPriceList(data.data);
    setPriceList(res);
    setLoading(false);
  };
  // const onGenderSuccess = (data) => {
  //   const res = convertGenderList(data.data);
  //   setGenderList(res);
  //   setLoading(false);
  // };
  // const onBloodGroupSuccess = (data) => {
  //   const res = convertGenderList(data.data);
  //   setBloodGroupList(res);
  //   setLoading(false);
  // };
  const onDoctorSuccess = (data) => {
    const res = convertDoctorrList(data.data);
    setDoctorList(res);
    setLoading(false);
  };
  // const onIdSuccess = (data) => {
  //   const res = convertGenderList(data.data);
  //   setIdList(res);
  //   setLoading(false);
  // };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message);
  };
  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(insuranceProviderAction(onListSuccess, onError));
      dispatch(priceListAction(onPriceSuccess, onError));
      // dispatch(genderAction(onGenderSuccess, onError));
      // dispatch(bloodGroupAction(onBloodGroupSuccess, onError));
      dispatch(doctorListAction(onDoctorSuccess, onError));
      // dispatch(idProofAction(onIdSuccess, onError));
    }
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          patient: values.patient,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };

  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;
    setLoading(true);
    if (values?.patient?.cmr_dob === "Invalid date") {
      delete values.patient.cmr_dob;
    }
    let dataSending = {
      ...values.patient,
      cmr_id: customerId,
      cmr_patient_id: patientId,
    };
    console.log(">>", dataSending, customerId, patientId);

    dispatch(
      updatePatientAction(
        {
          patientInfo: dataSending,
        },
        onSuccess,
        onError
      )
    );
  };

  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "patient");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);

  const phoneRegex = /^[0-9]\d{9}$/;
  const validationSchema = Yup.object().shape({
    patient: Yup.object().shape({
      cmr_emergency_contact_phone: Yup.string()
        .nullable()
        // .required("Phone is required")
        .matches(
          phoneRegex,
          "Please enter a valid 10-digit phone number starting with 6-9"
        ),
    }),
  });
  function format14Digits() {
    // ensure only digits and exactly 14 chars

    let data = JSON.parse(localStorage.getItem("customerAdmin"));
    let text = data?.patient?.cmr_abha_number;

    const digits = text.replace(/\D/g, "").slice(0, 14);

    return (
      digits.slice(0, 2) +
      "-" +
      digits.slice(2, 6) +
      "-" +
      digits.slice(6, 10) +
      "-" +
      digits.slice(10, 14)
    );
  }
  const sendOtpWithABHA = async (data) => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/request-login-otp-via-abha-number`,
        {
          abhaNumber: format14Digits(),
          accessToken: data,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response);
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      setLoading(false);
      setPopUp(true);

      return response.data;
    } catch (error) {
      errorToast(JSON.stringify(error?.response?.data?.data?.error?.loginId));
      console.error(
        "Error sending OTP:",
        error.response?.data?.data?.error?.message
      );
      setLoading(false);
      // throw error;
    }
  };

  const onTokenSuccess = (data) => {
    setAccessToken(data?.data?.sessionToken?.accessToken);
    setTokenExpiresIn(data?.data?.sessionToken?.expiresIn);
    console.log("token", data?.sessionToken?.accessToken);
    console.log("token", data);

    sendOtpWithABHA(data?.data?.sessionToken?.accessToken);
    setAccessToken(data?.data?.sessionToken?.accessToken);
    // setPopUp(true);
    // setLoading(false);
  };

  const onTokenFail = (data) => {
    setLoading(false);
    errorToast(data.message);
  };
  const onClickVerify = (values) => {
    if (values?.patient?.cmr_abha_number?.length === 14) {
      setLoading(true);
      dispatch(accessTokenAction(onTokenSuccess, onTokenFail));
    } else errorToast("Please enter a valid 14 digits ABHA number");
  };
  const today = new Date().toISOString().split("T")[0];

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          <LoadingOverlay isLoading={loading} />

          <UpdateLocalStorage values={values} />
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Patient2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Patient Info
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    write up the patient information
                  </label>
                </div>
              </div>
            </div>
            <div
              // key={index}
              className=" px-[34px] pt-[34px] pb-[10px]  flex-col  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
            >
              <div
                className="grid gap-x-3 gap-y-0 min-w-0"
                style={{
                  gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                }}
              >
                {shouldBeDisplay("cmr_name", page, customData) && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`patient.cmr_name`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_name",
                        customData
                      )}`}
                      allowSpecial={true}
                      label={handelLabel("cmr_name", customData)}
                      isDisabled={handelEnabled("cmr_name", page, customData)}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}
                {shouldBeDisplay("cmr_gender", page, customData) && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={genderList?.find(
                        (option) =>
                          option?.value === values?.patient?.cmr_gender
                      )}
                      label={handelLabel("cmr_gender", customData)}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelEnabled("cmr_gender", page, customData)}
                      // errMsgContainerClass="hidden"
                      id={`patient.cmr_gender`}
                      placeholder={`Select ${handelLabel(
                        "cmr_gender",
                        customData
                      )}`}
                      options={genderList}
                      name={`patient.cmr_gender`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}
                {shouldBeDisplay("cmr_abha_number", page, customData) && (
                  <div className="col-span-1">
                    <div className="flex flex-col gap-3 mb-[24px]">
                      <div className="flex flex-row gap-3">
                        <InputField
                          maxLength={30}
                          errMsgContainerClass="hidden"
                          // isRequired={true}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          name={`patient.cmr_abha_number`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_abha_number",
                            customData
                          )}`}
                          label={handelLabel("cmr_abha_number", customData)}
                          isDisabled={handelEnabled(
                            "cmr_abha_number",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}                        allowSpecial={true}
                          containerClass="w-full h-min"
                          handleChange={(e) => {
                            setFieldValue(
                              "patient.cmr_abha_number",
                              e.target.value
                            );
                            setABHAverified(false);
                          }}
                          value={values?.patient?.cmr_abha_number}
                        />

                        {/* {!ABHAverified && ( */}
                        <AddButton
                          prefixIcon={false}
                          // ref={submitRef}
                          isDisabled={disabled}
                          // icon={<Save size={14} />}
                          onclkFn={() => onClickVerify(values)}
                          text={
                            <span>{ABHAverified ? "verified" : "verify"}</span>
                          }
                          className="mt-[24px] h-[42px]
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--customer-sub-title-2-fw)]
    bg-[var(--customer-verify-bg)] hover:bg-[var(--customer-verify-bg)]
    "
                          type="button"
                        />
                        {/* )} */}
                      </div>
                      <div className="w-full flex gap-3 ">
                        <div
                          onClick={() => setFindABHApopup(true)}
                          className="w-full flex flex-row gap-2  p-[10px] whitespace-nowrap rounded-md 
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--customer-sub-title-2-fw)]
    bg-[var(--customer-verify-bg)] hover:bg-[var(--customer-verify-bg)]"
                        >
                          <div className="w-full justify-center flex flex-row gap-2">
                            <MobileIcon />
                            <span>Find Through Mobile Number</span>
                          </div>
                        </div>
                        <div
                          onClick={() => setCreateABHApopUp(true)}
                          className="w-full flex flex-row gap-2  p-[10px] whitespace-nowrap rounded-md 
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--customer-sub-title-2-fw)]
    bg-[var(--customer-verify-bg)] hover:bg-[var(--customer-verify-bg)]"
                        >
                          <div className="w-full justify-center flex flex-row gap-2">
                            <Plus size={17} strokeWidth={2} />
                            <span>Create ABHA Number</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {shouldBeDisplay("cmr_blood_group", page, customData) && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={bloodGroupList?.find(
                        (option) =>
                          option?.value === values?.patient?.cmr_blood_group
                      )}
                      label={handelLabel("cmr_blood_group", customData)}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelEnabled(
                        "cmr_blood_group",
                        page,
                        customData
                      )}
                      errMsgContainerClass="hidden"
                      id={`patient.cmr_blood_group`}
                      placeholder={`Select ${handelLabel(
                        "cmr_blood_group",
                        customData
                      )}`}
                      options={bloodGroupList}
                      name={`patient.cmr_blood_group`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}
                {/* <div className="flex gap-3 mt-[12px] mb-[24px]">
                <div className="w-full flex gap-3 ">
                  <div
                    onClick={() => setFindABHApopup(true)}
                    className="w-full flex flex-row gap-2  p-[10px] whitespace-nowrap rounded-md 
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--customer-sub-title-2-fw)]
    bg-[var(--customer-verify-bg)] hover:bg-[var(--customer-verify-bg)]"
                  >
                    <div className="w-full justify-center flex flex-row gap-2">
                      <MobileIcon />
                      <span>Find Through Mobile Number</span>
                    </div>
                  </div>
                  <div
                    onClick={() => setCreateABHApopUp(true)}
                    className="w-full flex flex-row gap-2  p-[10px] whitespace-nowrap rounded-md 
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--customer-sub-title-2-fw)]
    bg-[var(--customer-verify-bg)] hover:bg-[var(--customer-verify-bg)]"
                  >
                    <div className="w-full justify-center flex flex-row gap-2">
                      <Plus size={17} strokeWidth={2} />
                      <span>Create ABHA Number</span>
                    </div>
                  </div>
                </div>
                <div className="w-full"></div>
              </div> */}

                {shouldBeDisplay("cmr_dob", page, customData) && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      type="date"
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`patient.cmr_dob`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_dob",
                        customData
                      )}`}
                      label={handelLabel("cmr_dob", customData)}
                      isDisabled={handelEnabled("cmr_dob", page, customData)}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      max={today}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}
                {shouldBeDisplay("cmr_weight", page, customData) && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      type="number"
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`patient.cmr_weight`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_weight",
                        customData
                      )}`}
                      label={handelLabel("cmr_weight", customData)}
                      isDisabled={handelEnabled("cmr_weight", page, customData)}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}

                {shouldBeDisplay("cmr_height", page, customData) && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      type="number"
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`patient.cmr_height`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_height",
                        customData
                      )}`}
                      label={handelLabel("cmr_height", customData)}
                      isDisabled={handelEnabled("cmr_height", page, customData)}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}

                {shouldBeDisplay("cmr_primary_doctor", page, customData) && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={doctorList?.find(
                        (option) =>
                          option?.value === values?.patient?.cmr_primary_doctor
                      )}
                      label={handelLabel("cmr_primary_doctor", customData)}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelEnabled(
                        "cmr_primary_doctor",
                        page,
                        customData
                      )}
                      // errMsgContainerClass="hidden"
                      id={`patient.cmr_primary_doctor`}
                      placeholder={`Select ${handelLabel(
                        "cmr_primary_doctor",
                        customData
                      )}`}
                      options={doctorList}
                      name={`patient.cmr_primary_doctor`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}

                {shouldBeDisplay("cmr_id_proof_type", page, customData) && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={idList?.find(
                        (option) =>
                          option?.value === values?.patient?.cmr_id_proof_type
                      )}
                      label={handelLabel("cmr_id_proof_type", customData)}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelEnabled(
                        "cmr_id_proof_type",
                        page,
                        customData
                      )}
                      // errMsgContainerClass="hidden"
                      id={`patient.cmr_id_proof_type`}
                      placeholder={`Select ${handelLabel(
                        "cmr_id_proof_type",
                        customData
                      )}`}
                      options={idList}
                      name={`patient.cmr_id_proof_type`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}

                {shouldBeDisplay("cmr_id_proof_number", page, customData) && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`patient.cmr_id_proof_number`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_id_proof_number",
                        customData
                      )}`}
                      label={handelLabel("cmr_id_proof_number", customData)}
                      isDisabled={handelEnabled(
                        "cmr_id_proof_number",
                        page,
                        customData
                      )}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}
              </div>
              {(shouldBeDisplay("cmr_medical_history", page, customData) ||
                shouldBeDisplay("cmr_allergies", page, customData) ||
                shouldBeDisplay(
                  "cmr_current_medications",
                  page,
                  customData
                )) && (
                <div className="flex flex-col gap-8 ">
                  <label className=" text-[length:var(--customer-sub-title-2-fs)] font-[var(--alert-management-sub-title-fw)]">
                    Medical Information
                  </label>
                  <div>
                    {(shouldBeDisplay(
                      "cmr_medical_history",
                      page,
                      customData
                    ) ||
                      shouldBeDisplay("cmr_allergies", page, customData)) && (
                      <div className="flex flex-row gap-3">
                        {shouldBeDisplay(
                          "cmr_medical_history",
                          page,
                          customData
                        ) && (
                          <div className="w-full flex flex-col gap-2">
                            <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                              {handelLabel("cmr_medical_history", customData)}
                            </label>
                            <TextAreaField
                              name={`patient.cmr_medical_history`}
                              placeholder={`Enter ${handelLabel(
                                "cmr_medical_history",
                                customData
                              )}`}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              parentClass="flex  flex-col gap-2 w-full align-end "
                              label=""
                              isDisabled={handelEnabled(
                                "cmr_medical_history",
                                page,
                                customData
                              )}
                              defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                              containerClass="flex flex-col gap-2 w-full "
                            />
                          </div>
                        )}
                        {shouldBeDisplay("cmr_allergies", page, customData) && (
                          <div className="w-full flex flex-col gap-2">
                            <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                              {handelLabel("cmr_allergies", customData)}
                            </label>
                            <TextAreaField
                              name={`patient.cmr_allergies`}
                              placeholder={`Enter ${handelLabel(
                                "cmr_allergies",
                                customData
                              )}`}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              parentClass="flex  flex-col gap-2 w-full align-end "
                              label=""
                              isDisabled={handelEnabled(
                                "cmr_allergies",
                                page,
                                customData
                              )}
                              defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                              containerClass="flex flex-col gap-2 w-full "
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {shouldBeDisplay(
                      "cmr_current_medications",
                      page,
                      customData
                    ) && (
                      <div className="w-full flex flex-col gap-2">
                        <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                          {handelLabel("cmr_current_medications", customData)}
                        </label>
                        <TextAreaField
                          name={`patient.cmr_current_medications`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_current_medications",
                            customData
                          )}`}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          label=""
                          isDisabled={handelEnabled(
                            "cmr_current_medications",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                          containerClass="flex flex-col gap-2 w-full "
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(shouldBeDisplay(
                "cmr_emergency_contact_name",
                page,
                customData
              ) ||
                shouldBeDisplay(
                  "cmr_emergency_contact_phone",
                  page,
                  customData
                )) && (
                <div className="flex flex-col gap-8 ">
                  <label className=" text-[length:var(--customer-sub-title-2-fs)] font-[var(--alert-management-sub-title-fw)]">
                    {handelLabel("cmr_emergency_contact", customData)}
                  </label>

                  <div
                    className="grid  gap-x-3 gap-y-0  min-w-0"
                    style={{
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(400px, 1fr))",
                    }}
                  >
                    {shouldBeDisplay(
                      "cmr_emergency_contact_name",
                      page,
                      customData
                    ) && (
                      <div className="col-span-1">
                        <InputField
                          // errMsgContainerClass="hidden"
                          // isRequired={true}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          name={`patient.cmr_emergency_contact_name`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_emergency_contact_name",
                            customData
                          )}`}
                          label={handelLabel(
                            "cmr_emergency_contact_name",
                            customData
                          )}
                          isDisabled={handelEnabled(
                            "cmr_emergency_contact_name",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                          containerClass="w-full h-min"
                        />
                      </div>
                    )}
                    {shouldBeDisplay(
                      "cmr_emergency_contact_phone",
                      page,
                      customData
                    ) && (
                      <div className="col-span-1">
                        <InputField
                          // errMsgContainerClass="hidden"
                          type="number"
                          // isRequired={true}
                          maxLength={10}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          parentClass="flex  flex-col gap-2 w-full align-end "
                          name={`patient.cmr_emergency_contact_phone`}
                          placeholder={`Enter ${handelLabel(
                            "cmr_emergency_contact_phone",
                            customData
                          )}`}
                          label={handelLabel(
                            "cmr_emergency_contact_phone",
                            customData
                          )}
                          isDisabled={handelEnabled(
                            "cmr_emergency_contact_phone",
                            page,
                            customData
                          )}
                          defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                          containerClass="w-full h-min"
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(
                      `/edit-customer-admin/${customerId}`,
                      {
                        state: { tab: "Patient Info" },
                      }
                    )
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Patient;
